<div class="question">
  <h3 [innerHTML]="question.questionText"></h3>
  <div *ngIf="question.errorMessage && !question.isValid" class="label info red">
    <p [innerHTML]="question.errorMessage"></p>
  </div>

  <!--YesNo or MultipleChoice-->
  <div *ngIf="isQuestionClass(questionConst.yesNoClass, question.questionClass) ||
       isQuestionClass(questionConst.multipleChoiceClass, question.questionClass)">
  <label class="question-label radio"
       *ngFor="let answer of question.answers; let i = index"
       [ngClass]="{
          'selected': question.answerSelected === i
        }"
       [attr.data-id]="'question-' + question.id + '-answer-' + answer.id">
  
        <i class="radio-icon"></i>

        <span class="question-label-text">
          <span [innerHTML]="answer.answerText"></span>
          <span *ngIf="question.recommendedAnswerId === answer.id" class="ai-badge">AI</span>
        </span>

        <input 
          aria-label=""  
          [value]="answer.id" 
          type="radio" 
          (click)="onQuestionAnswered(getParseInt(answer.id))" 
          aria-label="">
      </label>
  </div>

  <!--FreeText or FreeTextNoValidation-->
  <div *ngIf="isQuestionClass(questionConst.freeTextClass, question.questionClass) ||
       isQuestionClass(questionConst.freeTextNoValidationClass, question.questionClass)">
    <span class="input-layer">
      <input aria-label=""  type="text" [value]="question.answerSelected" class="app-input"
             (blur)="onQuestionAnswered($event.target.value)"
             (keyup)="onPressEnterTextField($event)" aria-label="">
    </span>
  </div>

  <!--MultipleAnswers-->
  <div *ngIf="isQuestionClass(questionConst.multipleAnswerClass, question.questionClass)">
    <div id="checkbox-answers-empty-error">
      <div class="label info red" *ngIf="question.answerSelected.length === 0 && question.isCompulsary">
        You need to check at least one option.
      </div>
    </div>
    <label class="question-label checkbox"
           *ngFor="let answer of question.answers; let i = index"
           [ngClass]="{'selected': isAnswerSelected(answer.id)}" 
           [attr.data-id]="'question-' + question.id + '-answer-' + answer.id">
      <i class="radio-icon"></i>
      <span class="question-label-text" [innerHTML]="answer.answerText"></span>
      <!-- <input 
        aria-label=""  
        [value]="answer.id" 
        type="checkbox" 
        (click)="onQuestionAnswered(getAnswersList(answer.id))" 
        aria-label="" 
        role="checkbox"> -->
        <input 
        aria-label=""  
        [value]="answer.id" 
        type="checkbox" 
        (click)="onQuestionAnswered(getAnswersList(answer.id))" 
        aria-label="">
    </label>
  </div>

  <!--FreeTextDate-->
  <div *ngIf="isQuestionClass(questionConst.freeTextDateClass, question.questionClass)">
    <span class="input-layer">
      <p-calendar class="primeng-date" [(ngModel)]="question.answerSelected"
                  name="freetextdate-{{question.id}}"
                  (ngModelChange)="onQuestionAnswered(question.answerSelected)"
                  placeholder="11/11/2017" dateFormat="dd/mm/yy"></p-calendar>
    </span>
  </div>

  <!--Confirmation-->
  <!--we have no answers for confirmtion question-->

  <!--FreeTextPositiveNumber-->
  <div *ngIf="isQuestionClass(questionConst.freeTextPositiveNumberClass, question.questionClass)">
    <span class="input-layer">
      <input aria-label=""  type="text" [value]="question.answerSelected" class="app-input"
             (blur)="onQuestionAnswered($event.target.value)"
             (keyup)="onPressEnterTextField($event)" aria-label="">
    </span>
  </div>



</div>
